var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { fluid: "" } }, [
    !_vm.objetoEhVazio(_vm.tipoAtivo)
      ? _c("div", { staticClass: "mock" }, [
          _c("div", [
            _c(
              "div",
              { staticClass: "mock" },
              [
                _c("v-row", { staticClass: "d-flex flex-wrap pb-16 row" }, [
                  _c(
                    "div",
                    { staticClass: "bloco" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "d-flex flex-wrap pb-16 row" },
                        [
                          _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v(
                                      "Nome do Ativo " +
                                        _vm._s(_vm.detMov.length)
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                [
                                  _c("v-select", {
                                    staticClass: "select",
                                    attrs: {
                                      loading: _vm.loading,
                                      items: _vm.ativos2,
                                      attach: "",
                                      "item-text": "code",
                                      "menu-props": {
                                        bottom: true,
                                        offsetY: true
                                      },
                                      placeholder: "Selecione",
                                      color: "secondary",
                                      "return-object": true,
                                      required: "",
                                      dense: "",
                                      disabled: _vm.loading,
                                      outlined: "",
                                      rounded: ""
                                    },
                                    on: { change: _vm.changeActive },
                                    model: {
                                      value: _vm.ativo,
                                      callback: function($$v) {
                                        _vm.ativo = $$v
                                      },
                                      expression: "ativo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-row",
                        { staticClass: "d-flex flex-wrap pb-16 row" },
                        [
                          _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Descrição")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.descricao ? _vm.descricao : ""
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-row",
                        { staticClass: "d-flex flex-wrap pb-16 row" },
                        [
                          _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Estratégia")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.estrategia ? _vm.estrategia : ""
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Indice referência")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.indice ? _vm.indice : "") +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-row",
                        { staticClass: "d-flex flex-wrap pb-16 row" },
                        [
                          _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Indexador")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.indexador ? _vm.indexador : ""
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "bloco" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("FGC")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "column", attrs: { cols: "1" } },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.fgc ? _vm.fgc : "") + " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm.listMovimento.length > 0 && _vm.detMov.id == 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass:
                                    "d-flex flex-wrap pb-16 row rowTitMov"
                                },
                                [
                                  _c("span", [
                                    _vm._v("Excluir "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#f25a5a" } },
                                      [_vm._v("Movimentação")]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "d-flex flex-wrap pb-16 row ml"
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "bloco rowtitItList" },
                                    [
                                      _c("v-col", [_vm._v(" Data ")]),
                                      _c("v-col", [_vm._v(" V. Unitário ")]),
                                      _vm.productId == 5
                                        ? _c("v-col", [_vm._v(" Taxa ")])
                                        : _vm._e(),
                                      _c("v-col")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass:
                                    "d-flex flex-wrap pb-16 row br ml"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "bloco" },
                                    _vm._l(_vm.listMovimento, function(
                                      event,
                                      index
                                    ) {
                                      return _c(
                                        "v-row",
                                        {
                                          key: event.id,
                                          staticClass:
                                            "d-flex flex-wrap pb-16 row rowItList"
                                        },
                                        [
                                          _c("v-col", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.dateHelper.formatDate(
                                                    event.investmentDate
                                                  )
                                                )
                                            )
                                          ]),
                                          Math.abs(event.investedValue) > 1e-3
                                            ? _c("v-col", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currencyHelper.formatValue(
                                                        event.investedValue
                                                      )
                                                    )
                                                )
                                              ])
                                            : _vm._e(),
                                          Math.abs(event.investedValue) <= 1e-3
                                            ? _c("v-col", [
                                                _vm._v(" Resgate total")
                                              ])
                                            : _vm._e(),
                                          _vm.productId == 5
                                            ? _c("v-col", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.percentageHelper.formatStandard(
                                                        event.rate
                                                      )
                                                    )
                                                )
                                              ])
                                            : _vm._e(),
                                          _c("v-col", [
                                            event.tpMovimento != 1 &&
                                            index ==
                                              _vm.listMovimento.length - 1
                                              ? _c(
                                                  "div",
                                                  { staticClass: "btn-venda" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteListMov(
                                                              event
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Excluir")]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.listMovimento.length > 0 && _vm.detMov.id > 0
                        ? _c(
                            "div",
                            { staticClass: "teste" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass:
                                    "d-flex flex-wrap pb-16 row rowTitMov"
                                },
                                [
                                  _c("span", [
                                    _vm._v("Excluir "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#f25a5a" } },
                                      [_vm._v("Movimentação")]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "bloco" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap pb-16 row rowItExluir"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Deseja excutar Item do movimento Data:" +
                                            _vm._s(
                                              this.dateHelper.formatDate(
                                                _vm.detMov.investmentDate
                                              )
                                            ) +
                                            " Valor unitário " +
                                            _vm._s(
                                              this.currencyHelper.formatValue(
                                                _vm.detMov.investedValue
                                              )
                                            )
                                        )
                                      ]),
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "d-flex flex-wrap pb-16 row rowItExluir"
                                        },
                                        [
                                          _c("v-col", [
                                            _c(
                                              "div",
                                              { staticClass: "btn-venda" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "span-ok",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteListMov2(
                                                          _vm.detMov
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Sim ")]
                                                )
                                              ]
                                            )
                                          ]),
                                          _c("v-col"),
                                          _c("v-col", [
                                            _c(
                                              "div",
                                              { staticClass: "btn-venda" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.limparDetMov()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Não ")]
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }